(() => {
  if (window.cardAddToCartLoaded) return;
  window.cardAddToCartLoaded = true;

  const rootSelector = '[data-card-atc]';
  const cartUrl = (path) => `${window.Shopify.routes.root}${path}`;

  const getVariantId = (root) => {
    return root.dataset.variantId || root.querySelector('input[name="id"]')?.value || '';
  };

  const getCart = async () => {
    const response = await fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    if (!response.ok) throw new Error('Could not fetch cart');

    return response.json();
  };

  const getCartItemForVariant = (cart, variantId) => {
    return cart.items.find((item) => String(item.variant_id) === String(variantId));
  };

  const getCartQuantityForVariant = (cart, variantId) => {
    const item = getCartItemForVariant(cart, variantId);
    return item ? item.quantity : 0;
  };

  const setUiQuantity = (root, quantity) => {
    const addButton = root.querySelector('[data-card-atc-add]');
    const qtyBox = root.querySelector('[data-card-atc-qty]');
    const value = root.querySelector('[data-card-atc-value]');

    root.dataset.cartQuantity = String(quantity);

    if (value) value.textContent = String(Math.max(quantity, 1));

    if (quantity > 0) {
      if (addButton) addButton.hidden = true;
      if (qtyBox) qtyBox.hidden = false;
    } else {
      if (addButton) addButton.hidden = false;
      if (qtyBox) qtyBox.hidden = true;
    }
  };

  const notifyCartChanged = (cart) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            source: 'card-add-to-cart',
            itemCount: cart.item_count,
          },
        },
      })
    );
  };

  const waitForAddedQuantity = async (root) => {
    const variantId = getVariantId(root);

    for (let attempt = 0; attempt < 12; attempt += 1) {
      const cart = await getCart();
      const quantity = getCartQuantityForVariant(cart, variantId);

      if (quantity > 0) {
        setUiQuantity(root, quantity);
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, 250));
    }

    setUiQuantity(root, 0);
  };

  const updateCartQuantity = async (root, quantity) => {
    const variantId = getVariantId(root);

    if (!variantId || !/^\d+$/.test(String(variantId))) {
      throw new Error('This product could not be updated. Please refresh and try again.');
    }

    const currentCart = await getCart();
    const lineItem = getCartItemForVariant(currentCart, variantId);

    if (!lineItem) {
      setUiQuantity(root, 0);
      return 0;
    }

    const response = await fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: lineItem.key,
        quantity: Number(quantity),
      }),
    });

    const cart = await response.json();

    if (!response.ok) {
      throw new Error(cart.description || cart.message || 'Could not update cart');
    }

    notifyCartChanged(cart);

    return getCartQuantityForVariant(cart, variantId);
  };

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('[data-card-atc-add]');
    if (!addButton) return;

    const root = addButton.closest(rootSelector);
    if (!root) return;

    root.classList.add('is-loading');

    window.setTimeout(async () => {
      try {
        await waitForAddedQuantity(root);
      } catch (error) {
        console.error(error);
        setUiQuantity(root, 0);
      } finally {
        root.classList.remove('is-loading');
      }
    }, 0);
  });

  document.addEventListener('click', async (event) => {
    const root = event.target.closest(rootSelector);
    if (!root) return;

    const isPlus = event.target.closest('[data-card-atc-plus]');
    const isMinus = event.target.closest('[data-card-atc-minus]');

    if (!isPlus && !isMinus) return;

    event.preventDefault();
    event.stopPropagation();

    const previousQuantity = Number(root.dataset.cartQuantity || 0);
    const nextQuantity = isPlus ? previousQuantity + 1 : Math.max(previousQuantity - 1, 0);

    try {
      root.classList.add('is-loading');
      setUiQuantity(root, nextQuantity);

      const confirmedQuantity = await updateCartQuantity(root, nextQuantity);
      setUiQuantity(root, confirmedQuantity);
    } catch (error) {
      console.error(error);
      setUiQuantity(root, previousQuantity);
      alert(error.message || 'Could not update cart. Please try again.');
    } finally {
      root.classList.remove('is-loading');
    }
  });
})();